var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99985 13L18.5856 13L15.2927 16.2929L16.707 17.7071L22.4141 12L16.707 6.29289L15.2927 7.70711L18.5856 11L7.99985 11L7.99985 13ZM3.99985 21L12.9998 21L12.9998 19L3.99985 19L3.99985 5L12.9998 5L12.9998 3L3.99985 3C2.89528 3 1.99985 3.89543 1.99985 5L1.99985 19C1.99985 20.1046 2.89528 21 3.99985 21Z",
    fill: "#ACD6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrow);
export default __webpack_public_path__ + "static/media/share-arrow.5264c545f37825340fbff0ee5a8c4aa4.svg";
export { ForwardRef as ReactComponent };